// extracted by mini-css-extract-plugin
module.exports = {"terms":"styles_terms__qvg8t","message":"styles_message__AGXMm"};